import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { endpoint } from '../helpers/constantes';
import { connect } from 'react-redux';
import  Navigation from './Navigation/Navigation'
import { modificaLoader } from '../actions/LoaderActions';

class CadastroOlt extends Component {

  state = {
    nome: '',
    ip: '',
    alert: {
      show: false,      
      title: 'Aviso',
      message: '',
      type: {
        warning: false,
        success: false,
        danger: false,
      }
    }
  }

  limpar = () => {
    document.getElementById("cad-olt").reset();
    this.setState({
      nome: '',
      ip: '',
    })
  }

  cadastrar = (e) => {
    this.props.modificaLoader(true);
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/olt`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({nome: this.state.nome, 
      ip: this.state.ip})})
    .then(result => {
      if (result.ok) {
        this.props.modificaLoader(false);
        this.limpar();
        this.setState({
          alert: {
            show: true,             
            title: 'Sucesso',
            message: result.statusText,
            type: {
              warning: false,
              success: true,
              danger: false,
            }
          }
        })
      }else{
        this.props.modificaLoader(false);
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
    })    
    .catch(err => {
      this.props.modificaLoader(false);
      this.setState({
        alert: {
          show: true,
          title: 'Erro! Estamos sem conectividade ?',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  };

  render() {
    return (
      <Navigation history={this.props.history}>
        <h1>Cadastre uma nova OLT</h1>
        <p style={{fontSize: '12px', color: '#aeaeae'}}>Somente OLT FiberHome</p>            
        <form id="cad-olt" onSubmit={this.cadastrar}>
          <div className="form-group">
            Nome:
            <input
            ref={(input) => { this.nome = input; }} 
            className="form-control" 
            type="text" 
            name="nome" 
            value={this.props.nome} 
            onChange={event => this.setState({nome: event.target.value})} 
            required
            autoFocus/>
          </div>
          <div className="form-group">
            IP:
            <input 
            className="form-control" 
            type="text" 
            name="ip" 
            value={this.props.ip} 
            onChange={event => this.setState({ip: event.target.value})} 
            required/>
          </div>
          <div className="form-group">
            <button 
            className="btn btn-outline-danger" 
            type="submit" 
            name="Cadastrar">
            Cadastrar
            </button>
            <button 
            className="btn btn-outline-secondary ml-3" 
            type="button" 
            onClick={this.limpar} 
            name="Limpar">
            Limpar
            </button>
          </div>
        </form>
        <SweetAlert {...this.state.alert.type}
          title={this.state.alert.title}
          show={this.state.alert.show}
          onConfirm={() => {
            this.setState({ ...this.state, alert: {show: false, title: ''}})
            this.nome.focus();
          }}>
          {this.state.alert.message}
        </SweetAlert>
      </Navigation>
    );
  }
}
const mapStateToProps = state => ({
  token: state.LoginReducer.token,
});

export default connect(mapStateToProps, { modificaLoader })(CadastroOlt);


// WEBPACK FOOTER //
// ./src/components/CadastroOlt.js